<template>
  <div class="spark">
    <Banner :top="0" />
    <main>
      <div
        ref="page"
        class="banner_box"
        :style="[{height:clientHeight+'px'},{maxHeight:clientHeight}]"
      >
        <div class="img_box">
          <div class="left">
            <div class="left_txt_box">
              <div class="left_one ">
                <img
                  src="~@/assets/newSpark/banner_logo.png"
                  alt=""
                >
              </div>
              <!-- <div
                v-if="clientWidth<630"
                style="width:100%"
              /> -->
              <div
                class="left_two"
                style="cursor: pointer"
              >
                <img
                  src="~@/assets/newSpark/2299.png"
                  alt=""
                >
                <div
                  id="toTaobao"
                  class="totaobao"
                  :src="buttonSrc"
                  alt=""
                  @click="openTmallFun"
                >
                  <!-- <img
                    id="toTaobao"
                    :src="buttonSrc"
                    alt=""
                    @mouseenter="buttonSrc = require('@/assets/newSpark/hover_button.svg')"
                    @mouseleave="buttonSrc = require('@/assets/newSpark/Default_button.svg')"
                    @click="toTaobaoFun"
                  > -->
                  <span>上天猫抢购</span>
                  <!-- <img
                    src="~@/assets/newSpark/spark_jiantou.svg"
                    alt=""
                  > -->
                </div>
              </div>
            </div>
            <div
              v-if="clientWidth>660"
              class="left_button_box"
            >
              <img
                src="~@/assets/newSpark/ios_white.svg"
                alt=""
                style="cursor: pointer"
                @click="downIosFun"
              >
              <a
                :href="androidUrl"
                download=""
                style="cursor:pointer"
                @click="downloadAndroidFun"
              >
                <img
                  src="~@/assets/newSpark/android_white.svg"
                  alt=""
                >
                <!-- <p style="text-align:center;color:#fff;font-size:12px;">安卓版即将上线</p> -->
              </a><br>
              <p>
                免费应用程序
              </p>
            </div>
          </div>
          <div class="right">
            <img
              src="~@/assets/newSpark/yinxiang.png"
              alt=""
            >
          </div>
        </div>
        <div
          v-if="clientWidth<=660"
          class="left_button_box"
          style="display:flex;align-items:flex-start;margin-top:-100px;"
        >
          <img
            style="margin-right:32px;cursor: pointer"
            src="~@/assets/newSpark/ios_white.svg"
            alt=""
            @click="downIosFun"
          >
          <a
            :href="androidUrl"
            style="cursor:pointer"
            download=""
            @click="downloadAndroidFun"
          >
            <img
              src="~@/assets/newSpark/android_white.svg"
              alt=""
            >
          </a>
          <p style="">
            免费应用程序
          </p>
        </div>
        <div
          v-if="clientWidth<1024"
          class="sanjiao3"
          style="position:absolute;bottom:-1px;width:100%;"
        >
          <img
            style="width:100%"
            src="~@/assets/newSpark/banner_sanjiao.svg"
            alt=""
          >
        </div>
      </div>
      <!-- badge -->
      <div class="badge">
        <img
          src="~@/assets/newSpark/GuitarPlayer2020 (2).png"
          alt=""
        >
        <img
          src="~@/assets/newSpark/GuitarPlayer2020 (1).png"
          alt=""
        >
      </div>
      <!-- function_box -->
      <div class="function_box">
        <ul>
          <li class="item">
            <img
              src="~@/assets/newSpark/fun1.png"
              alt=""
            >
            <h4>智能模拟乐队伴奏</h4>
            <p>自动学习演奏风格</p>
            <p>生成贝斯 / 鼓轨伴奏</p>
          </li>
          <li class="item">
            <img
              src="~@/assets/newSpark/fun2.png"
              alt=""
            >
            <h4>海量练习曲库</h4>
            <p>匹配腾讯等流媒体百万曲库</p>
            <p>实时生成并显示和弦</p>
          </li>
          <li class="item">
            <img
              src="~@/assets/newSpark/fun3.png"
              alt=""
            >
            <h4>智能语音助理</h4>
            <p>语音指令流畅操控</p>
            <p>解放双手轻松演奏</p>
          </li>
          <li class="item">
            <img
              src="~@/assets/newSpark/fun4.png"
              alt=""
            >
            <h4>BIAS 音色引擎</h4>
            <p>内置 BIAS 建模引擎</p>
            <p>重现电子管音箱动态</p>
          </li>
        </ul>
        <ul>
          <li class="item">
            <img
              src="~@/assets/newSpark/fun5.png"
              alt=""
            >
            <h4>海量音色和效果</h4>
            <p>10,000+ 预设音色云下载</p>
            <p>自创专属单块效果链</p>
          </li>
          <li class="item">
            <img
              src="~@/assets/newSpark/fun6.png"
              alt=""
            >
            <h4>多功能蓝牙音箱</h4>
            <p>高保真全频段音频技术</p>
            <p>40W 全音域扬声器</p>
          </li>
          <li class="item">
            <img
              src="~@/assets/newSpark/fun7.png"
              alt=""
            >
            <h4>USB 数码音频输出</h4>
            <p>内置声卡，可直连电脑</p>
            <p>家庭录音分享乐趣</p>
          </li>
          <li class="item">
            <img
              src="~@/assets/newSpark/fun8.png"
              alt=""
            >
            <h4>适用于多种吉他</h4>
            <p>电吉他 / 贝斯 / 木吉他通用</p>
            <p>一箱多能高性价比</p>
          </li>
        </ul>
        <div
          v-if="clientWidth<1024"
          class="sanjiao2 "
        >
          <img
            style="width:100%;margin-bottom: -1px;"
            src="~@/assets/newSpark/sanjiao2.svg"
            alt=""
          >
        </div>
      </div>
      <!-- fun_img_box -->
      <div class="fun_img_box">
        <ul>
          <li class="item">
            <div
              v-if="clientWidth>1024"
              style="height:80px;"
            />
            <div
              v-if="clientWidth<1024 &&clientWidth>588 "
              style="height:60px;"
            />
            <div
              v-if="clientWidth<588 "
              style="height:40px;"
            />
            <div class="fun_txt">
              <h3>智能模拟乐队伴奏</h3>
              <p>Spark 独创音箱和应用程序结合，能自动学习你的演奏风格，生成专属贝斯和鼓轨为你伴奏。马上召唤量身打造的模拟乐队，伴你玩琴嗨翻天。</p>
            </div>
            <div class="fun_img">
              <img
                v-if="clientWidth>588"
                src="~@/assets/newSpark/ad1.png"
                alt=""
              >
              <img
                v-else
                src="~@/assets/newSpark/ad1-1.png"
                alt=""
              >
            </div>
          </li>
          <li class="item">
            <div
              v-if="clientWidth>1024"
              style="height:80px;"
            />
            <div
              v-if="clientWidth<1024 &&clientWidth>588 "
              style="height:60px;"
            />
            <div
              v-if="clientWidth<588 "
              style="height:40px;"
            />
            <div class="fun_txt">
              <h3>海量练习曲库</h3>
              <p>匹配腾讯流媒体百万曲库，即时生成和弦并显示在屏幕，任你即兴玩耍。可循环播放难度较高段落，演奏更易上手。</p>
            </div>
            <div class="fun_img">
              <img
                v-if="clientWidth>588"
                src="~@/assets/newSpark/ad2.png"
                alt=""
              >
              <img
                v-else
                src="~@/assets/newSpark/ad2-1.png"
                alt=""
              >
            </div>
          </li>
          <li class="item">
            <div
              v-if="clientWidth>1024"
              style="height:80px;"
            />
            <div
              v-if="clientWidth<1024 &&clientWidth>588 "
              style="height:60px;"
            />
            <div
              v-if="clientWidth<588 "
              style="height:40px;"
            />
            <div class="fun_txt">
              <h3>智能语音助理</h3>
              <p>内置应用程序能识别并响应你的语音指令，双手无需离开吉他即可互动操控，创造全新轻松玩琴体验。</p>
            </div>
            <div
              class="fun_img"
              style="position:relative;"
            >
              <img
                v-if="clientWidth>588"
                src="~@/assets/newSpark/ad3.png"
                alt=""
              >
              <img
                v-else
                src="~@/assets/newSpark/ad3-1.png"
                alt=""
              >
              <div
                v-if="clientWidth<1024"
                class="sanjiao3"
                style="position:absolute;bottom:0;width:100%;"
              >
                <img
                  style="width:100%"
                  src="~@/assets/newSpark/sanjiao3.svg"
                  alt=""
                >
              </div>
            </div>
          </li>
          <li
            class="item"
            style="background: #101010;"
          >
            <div
              v-if="clientWidth>1024"
              style="height:80px;"
            />
            <div
              v-if="clientWidth<1024 &&clientWidth>588 "
              style="height:60px;"
            />
            <div
              v-if="clientWidth<588 "
              style="height:40px;"
            />
            <div class="fun_txt">
              <h3>获奖音色引擎</h3>
              <p>荣获国际吉他大奖的 BIAS 音色引擎，提供超拟真的虚拟电子管音箱，及多功能高品质的效果器。混合 / 匹配 / 调整仿如专业录音棚效果。助你快速创建音色，奏出动人旋律。</p>
            </div>
            <div
              class="fun_img"
              style="position:relative;"
            >
              <img
                v-if="clientWidth>588"
                src="~@/assets/newSpark/ad4.png"
                alt=""
              >
              <img
                v-else
                src="~@/assets/newSpark/ad4-1.png"
                alt=""
              >
            </div>
          </li>
          <li
            class="item"
            style="background: #101010;"
          >
            <div
              v-if="clientWidth>1024"
              style="height:80px;"
            />
            <div
              v-if="clientWidth<1024 &&clientWidth>588 "
              style="height:60px;"
            />
            <div
              v-if="clientWidth<588 "
              style="height:40px;"
            />
            <div class="fun_txt">
              <h3>海量音色和效果</h3>
              <p>直接访问并下载超过 10,000 种预置音色，创建个性化单块效果链，所有预设可在音色云在线社区免费下载及分享，一把吉他玩出无穷变化的音色效果。</p>
            </div>
            <div
              class="fun_img"
              style="position:relative;"
            >
              <img
                v-if="clientWidth>588"
                src="~@/assets/newSpark/ad5.png"
                alt=""
              >
              <img
                v-else
                src="~@/assets/newSpark/ad5-1.png"
                alt=""
              >
            </div>
          </li>
          <div
            v-if="clientWidth<1024"
            class="sanjiao4"
          >
            <img
              style="width:100%"
              src="~@/assets/newSpark/sanjiao4.svg"
              alt=""
            >
          </div>
          <li
            class="item"
            style="background: #fff;"
          >
            <div
              v-if="clientWidth>1024"
              style="height:80px;"
            />
            <div
              v-if="clientWidth<1024 &&clientWidth>588 "
              style="height:60px;"
            />
            <div
              v-if="clientWidth<588 "
              style="height:40px;"
            />
            <div class="fun_txt">
              <h3 style="color: #E02020;">
                多功能蓝牙音箱
              </h3>
              <p style="color: #585858;">
                配置全频段 40W 扬声器，精细调校的低频反射孔，清晰通透的中高频及深厚丰润的低频，并可蓝牙连接播放。除练琴以外，轻松倾听你喜爱的高品质音乐。
              </p>
            </div>
            <div
              class="fun_img"
              style="position:relative;"
            >
              <img
                v-if="clientWidth>588"
                src="~@/assets/newSpark/ad20.png"
                alt=""
              >
              <img
                v-else
                src="~@/assets/newSpark/ad20-1.png"
                alt=""
              >
            </div>
          </li>
          <li
            class="item"
            style="background: #fff;"
          >
            <div
              v-if="clientWidth>1024"
              style="height:80px;"
            />
            <div
              v-if="clientWidth<1024 &&clientWidth>588 "
              style="height:60px;"
            />
            <div
              v-if="clientWidth<588 "
              style="height:40px;"
            />
            <div class="fun_txt">
              <h3 style="color: #E02020;">
                USB 数码音频输出
              </h3>
              <p style="color: #585858;">
                内置声卡，以 USB 与电脑连接即可录音，使用录音软件能随时记录你转瞬即逝的即兴演奏灵感，并分享给你的朋友。
              </p>
            </div>
            <div
              class="fun_img"
              style="position:relative;"
            >
              <img
                v-if="clientWidth>588"
                src="~@/assets/newSpark/ad7.png"
                alt=""
              >
              <img
                v-else
                src="~@/assets/newSpark/ad7-1.png"
                alt=""
              >
            </div>
          </li>
          <li
            class="item"
            style="background: #fff;"
          >
            <div
              v-if="clientWidth>1024"
              style="height:80px;"
            />
            <div
              v-if="clientWidth<1024 &&clientWidth>588 "
              style="height:60px;"
            />
            <div
              v-if="clientWidth<588 "
              style="height:40px;"
            />
            <div class="fun_txt">
              <h3 style="color: #E02020;">
                适用于多种吉他
              </h3>
              <p style="color: #585858;">
                全频段技术音色，可完美匹配电吉他 / 贝斯 / 木吉他，一台音箱满足多个愿望，从此换琴不需换箱，想怎么玩就怎么玩。
              </p>
            </div>
            <div
              class="fun_img"
              style="position:relative;"
            >
              <img
                v-if="clientWidth>588"
                src="~@/assets/newSpark/ad8.png"
                alt=""
              >
              <img
                v-else
                src="~@/assets/newSpark/ad8-1.png"
                alt=""
              >
            </div>
          </li>
          <li
            class="item"
            style="background: #fff;"
          >
            <div
              v-if="clientWidth>1024"
              style="height:80px;"
            />
            <div
              v-if="clientWidth<1024 &&clientWidth>588 "
              style="height:60px;"
            />
            <div
              v-if="clientWidth<588 "
              style="height:40px;"
            />
            <div class="fun_txt">
              <h3
                v-if="clientWidth>1024 "
                style="color: #101010;font-weight:400;font-size:36px;letter-spacing:20px"
              >
                外观与技术规格
              </h3>
              <h3
                v-else
                style="color: #101010;font-weight:400;font-size:20px;letter-spacing:10px"
              >
                外观与技术规格
              </h3>
            </div>
            <div
              class="fun_img"
              style="position:relative;"
            >
              <img
                src="~@/assets/newSpark/ad9.png"
                alt=""
              >
              <img
                src="~@/assets/newSpark/ad10.png"
                alt=""
              >
              <img
                src="~@/assets/newSpark/ad11.png"
                alt=""
              >
              <img
                src="~@/assets/newSpark/ad12.png"
                alt=""
              >
              <img
                src="~@/assets/newSpark/ad13.png"
                alt=""
              >
            </div>
          </li>
        </ul>
      </div>
      <!-- check_box -->
      <div class="check_box">
        <div class="check_left">
          <div class="check_item">
            <h4 class="check_title">
              音频规格
            </h4>
            <ul>
              <li class="check_li">
                <div>
                  <h5>频响范围</h5>
                  <p>20-20,000 Hz</p>
                </div>
                <div>
                  <h5>立体声/单声道</h5>
                  <p>立体声</p>
                </div>
              </li>
              <li class="check_li">
                <div>
                  <h5>最大声压级</h5>
                  <p>116 dB SPL @1m</p>
                </div>
                <div>
                  <h5>箱体原理</h5>
                  <p>低频反射管</p>
                </div>
              </li>
              <li class="check_li">
                <div>
                  <h5>功率放大器</h5>
                  <p>40 瓦 D 类放大器</p>
                </div>
                <div>
                  <h5>总阻抗</h5>
                  <p>4 ohms</p>
                </div>
              </li>
              <li class="check_li">
                <div>
                  <h5>扬声器</h5>
                  <p>两个定制设计的 4 英寸扬声器</p>
                </div>
              </li>
            </ul>
          </div>
          <div class="check_item">
            <h4 class="check_title">
              硬件控制项目与接口
            </h4>
            <ul>
              <li class="check_li">
                <div>
                  <h5>顶部面板控制</h5>
                  <p>音箱类型<br>增益、低频、中频、高频、主音量、调制、延时、混响<br>输出音量<br>音乐音量<br>4 个可编辑预置音色按键<br>点击定速/调音表按键</p>
                </div>
              </li>
              <li class="check_li">
                <div>
                  <h5>板载效果</h5>
                  <p>30 种音箱模型<br>40 种效果（噪声门、压缩、失真、调制、延时、混响）</p>
                </div>
              </li>
              <li class="check_li">
                <div>
                  <h5>有线连接</h5>
                  <p>
                    1/4 英寸吉他输入<br>
                    1/8 英寸辅助输入<br>
                    1/8 英寸耳机输出<br>
                  </p>
                </div>
                <div>
                  <h5>无线连接</h5>
                  <p>Bluetooth Audio</p>
                </div>
              </li>
              <li class="check_li">
                <div>
                  <h5>USB 音频</h5>
                  <p>用于录音的 USB 接口<br>1 路输入 x 2 路输出</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="check_right">
          <div class="check_item">
            <h4 class="check_title">
              电源
            </h4>
            <ul>
              <li class="check_li">
                <div>
                  <h5>市电输入电压</h5>
                  <p>100 - 240 伏</p>
                </div>
                <div>
                  <h5>市电频率</h5>
                  <p>50/60 Hz</p>
                </div>
              </li>
            </ul>
          </div>
          <div class="check_item">
            <h4 class="check_title">
              物理规格
            </h4>
            <ul>
              <li class="check_li">
                <div>
                  <h5>尺寸</h5>
                  <p>350 x 180 x 190 毫米</p>
                </div>
                <div>
                  <h5>重量</h5>
                  <p>5.2 公斤</p>
                </div>
              </li>
              <li class="check_li">
                <div>
                  <h5>包复材料</h5>
                  <p>黑色蒙皮</p>
                </div>
                <div>
                  <h5>网布</h5>
                  <p>定制黑色/褐色</p>
                </div>
              </li>
              <li class="check_li">
                <div>
                  <h5>提把</h5>
                  <p>可取下的皮质提把</p>
                </div>
              </li>
            </ul>
          </div>
          <div class="check_item">
            <h4 class="check_title">
              软件
            </h4>
            <ul>
              <li class="check_li">
                <div>
                  <p>iOS 和安卓版 Spark 应用程序</p>
                </div>
              </li>
            </ul>
          </div>
          <div class="check_item">
            <h4 class="check_title">
              装箱内容
            </h4>
            <ul>
              <li class="check_li">
                <div>
                  <p> Spark 音箱<br>USB 连接线<br>电源适配器</p>
                </div>
                <div>
                  <p>快速入门指南</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- time_box -->
      <div class="time_box">
        <div class="time_content">
          <div class="time_content_box">
            <h2>
              <img
                src="~@/assets/newSpark/time_title.png"
                alt=""
              >
            </h2>
            <h3>&nbsp;连接未来的声音</h3>
            <div class="time_txt">
              <p>音乐不只是聆听，更是创造、分享、发现、参与和连接。从免费手机应用程序到智能连接的效果单块和巡演级音箱，Positive Grid 持续站在音乐未来科技的最前沿，颠覆过往认知，为更多音乐爱好者推陈出新。</p>
              <p>时至今日，我们已成为一个全球性社区，来自全球的无数音乐爱好者在这里分享他们对音乐的激情、创造新的音色、追寻自己的梦想并乐在其中。</p>
            </div>
            <div
              ref="wrapper"
              class="wrapper"
              style="overflow:hidden;"
            >
              <ul
                class="content"
                style="width:630px;height:228px;"
              >
                <li>
                  <img
                    style="width:630px;height:228px;"
                    src="~@/assets/newSpark/Timeline.png"
                    alt=""
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </main>

    <footer-common />
  </div>
</template>
<script>
import Banner from '@/components/banner'
import FooterCommon from '@/components/footer-common'
// eslint-disable-next-line no-unused-vars
import BScroll from 'better-scroll'
import axios from 'axios'
import { mapState } from 'vuex'
import { NEW_API_URL } from '@/urls'

export default {
  components: {
    Banner,
    FooterCommon
  },

  data () {
    return {
      clientHeight: document.documentElement.clientHeight,
      clientWidth: document.documentElement.clientWidth,
      scroll: {},
      buttonSrc: require('@/assets/newSpark/Default_button.svg'),
      androidUrl: '',
      num: 0
    }
  },
  computed: {
    ...mapState('Auth', {
      token: 'token'
    })
  },
  created () {
    this.downloadAndroidFun()
  },
  mounted () {
    // set window.body.offsetHeight
    this.clientHeight = document.documentElement.clientHeight
    this.clientWidth = document.documentElement.clientWidth
    // watch onresize
    const _this = this
    window.onresize = function temp () {
      _this.clientHeight = document.documentElement.clientHeight
      _this.clientWidth = document.documentElement.clientWidth
    }
    this.$nextTick(() => {
      this.scroll = new BScroll(this.$refs.wrapper, {
        scrollX: true,
        click: true
      })
    })
  },
  methods: {
    _isMobile () {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      return flag
    },
    openTmallFun () {
      if (this._isMobile()) {
        window.open('https://s.tb.cn/c.0uYgIF')
      } else {
        window.open(
          'https://detail.tmall.com/item.htm?spm=a220m.1000858.1000725.11.98752449TovXsp&id=638402551111&skuId=4611686656829939015&user_id=2210522335310&cat_id=2&is_b=1&rn=c8237f160fea8795029c3f3876107af9'
        )
      }
    },
    //   download android
    async downloadAndroidFun () {
      this.num += 1
      try {
        await axios
          .get(`${NEW_API_URL}/api/package/spark`, {
            headers: {
              //   'Authorization': `JWT ${this.token || window.localStorage.getItem('PG_TOKEN')}`,
              'Content-Type': 'application/json;charset=UTF-8'
            }
          })
          .then((res) => {
            if (res.data.android) {
              let userAgent = navigator.userAgent.toLowerCase()
              if (
                userAgent.indexOf('android') > -1 &&
                                this.num > 1
              ) {
                window.open(res.data.android.download_url)
              } else {
                this.androidUrl = res.data.android.download_url
              }
            }
          })
          .catch((err) => {
            console.error('Fail!!', err)
          })
      } catch (err) {
        console.log(err, '请求出错！')
      }
    },
    // download ios
    downIosFun () {
      window.open('https://apps.apple.com/cn/app/id1516758668')
    },
    toTaobaoFun () {
      window.open(
        'https://item.taobao.com/item.htm?spm=a2oq0.12575281.0.0.353c1debCzShxX&ft=t&id=622016680358'
      )
    }
  }
}
</script>
<style lang="scss" scoped>
.spark {
    margin: 0;
    padding: 0;
    font-family: Noto Sans SC;
    .banner_box {
        margin: 0;
        padding: 0;
        // padding-top: 54px;
        background: #e02020;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        min-height: 740px;
        position: relative;
        // @media (max-width: 1024px) {
        //     padding-top: 80px;
        // }

        @media (max-height: 1204px) {
            padding-top: 106px;
        }
        @media (max-height: 748px) {
            padding-top: 54px;
        }
        .img_box {
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            z-index: 1;
            .left {
                .left_txt_box {
                    .left_one {
                        margin-bottom: 32px;
                        width: 387px;
                        img {
                            width: 387px;
                            height: 163px;
                        }
                    }
                    .left_two {
                        margin-bottom: 80px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        & > img:nth-child(1) {
                            // margin-bottom: 16px;
                            margin-right: 16px;
                            width: 166px;
                            height: 36px;
                        }
                        .totaobao {
                            display: flex;
                            width: 152px;
                            height: 44px;
                            border-radius: 22px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            background: #f9cb7c;
                            font-weight: bold;
                            font-size: 14px;
                            color: #400808;
                            img {
                                margin-left: 5px;
                            }
                        }
                        & > img:nth-child(2) {
                            width: 200px;
                            height: 44px;
                        }
                    }
                }

                .left_button_box {
                    display: flex;
                    justify-content: center;
                    position: relative;
                    img {
                        width: 144px;
                        height: 44px;
                    }
                    > img:nth-child(1) {
                        margin-right: 32px;
                    }
                    p {
                        position: absolute;
                        width: 100%;
                        top: 53px;
                        text-align: center;
                        font-weight: normal;
                        font-size: 12px;
                        color: #fff;
                    }
                }
            }
            .right {
                margin: 0 115px;
                width: 640px;
                height: 620px;
            }
            @media (max-width: 1204px) {
                flex-wrap: wrap;
                justify-content: center;
                .left {
                    width: 920px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    flex-wrap: wrap;
                    .left_txt_box {
                        display: flex;
                        width: 460px;
                        margin-bottom: 48px;
                        .left_one {
                            margin-right: 80px;
                            margin-bottom: 0;
                            img {
                                width: 200px;
                                height: 85px;
                            }
                        }
                        .left_two {
                            display: block;
                            margin-bottom: 0;
                            margin-right: 0;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            flex-wrap: wrap;
                            & > img:nth-child(1) {
                                margin-right: 0px;
                            }
                            .totaobao {
                                width: 180px;
                            }
                        }
                    }

                    .left_button_box {
                        width: 100%;
                        // text-align: center;
                        display: flex;
                        justify-content: center;
                        position: relative;
                        p {
                            position: absolute;
                            width: 100%;
                            top: 53px;
                            text-align: center;
                            font-weight: normal;
                            font-size: 12px;
                            color: #fff;
                        }
                    }
                }
            }
            @media (max-width: 785px) {
                .left {
                    width: 920px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    .left_one {
                        margin-right: 80px;
                        margin-bottom: 0;
                    }
                    .left_two {
                        margin-bottom: 0;
                        .totaobao {
                            width: 168px;
                        }
                    }
                }
                .right {
                    margin: 0;
                    width: 520px;
                    height: 504px;
                }
            }
            @media (max-width: 660px) {
                .left {
                    width: 920px;
                    display: flex;
                    justify-content: center;
                    flex-wrap: wrap;
                    .left_txt_box {
                        width: 100%;
                        display: flex;
                        flex-wrap: wrap;
                        justify-content: center;
                        margin-bottom: 0;
                        .left_one {
                            display: flex;
                            justify-content: center;
                            margin-right: 0;
                            margin-bottom: 34px;
                            width: 100%;
                            img {
                                width: 200px;
                                height: 85px;
                            }
                        }
                        .left_two {
                            display: flex;
                            justify-content: center;
                            flex-wrap: wrap;
                            margin-bottom: 0;
                            width: 300px;
                            & img:nth-child(1) {
                                margin-bottom: 14px;
                            }
                            .totaobao {
                                width: 200px;
                            }
                        }
                    }
                }
                .right {
                    margin: 0;
                    width: 360px;
                    height: 349px;
                }
            }
        }
        .sanjiao {
            width: 100%;
            height: 7rem;
            position: absolute;
            left: 0;
            bottom: -1px;
            background: url("~@/assets/newSpark/banner_sanjiao.svg") no-repeat;
            background-size: 100% 100%;
            @media (max-width: 558px) {
                background: url("~@/assets/newSpark/banner_sanjiao_mini.svg")
                    no-repeat;
                width: 100%;
                height: 3.5rem;
                background-size: 100% 100%;
            }
        }
    }
    .badge {
        background: #fff;
        padding-top: 72px;
        display: flex;
        justify-content: center;
        img {
            width: 182px;
            height: 132px;
        }
        img:nth-child(1) {
            margin-right: 128px;
        }
        @media (max-width: 1024px) {
            padding-top: 36px;
        }
        @media (max-width: 558px) {
            img {
                width: 144px;
                height: 108px;
            }
            img:nth-child(1) {
                margin-right: 24px;
            }
        }
    }
    .function_box {
        background: #fff;
        margin-top: -1px;
        ul {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            padding: 80px 0;
            &:nth-child(1) {
                margin-bottom: 46px;
                padding-bottom: 0;
            }
            &:nth-child(2) {
                padding-top: 0;
            }
            @media (max-width: 1024px) {
            }
            @media (max-width: 558px) {
                padding: 64px 0;
                &:nth-child(1) {
                    margin-bottom: 0;
                    padding-bottom: 0;
                }
                &:nth-child(2) {
                    margin-bottom: 0;
                    padding-top: 0;
                }
            }
            .item {
                width: 210px;
                text-align: center;
                display: flex;
                flex-wrap: wrap;
                justify-content: center;
                font-size: 16px;
                font-weight: bold;
                h4 {
                    line-height: 30px;
                    color: #101010;
                }
                p {
                    font-size: 14px;
                    font-weight: normal;
                    line-height: 20px;
                    color: #878787;
                }
                img {
                    width: 40px;
                    height: 40px;
                }
                & > * {
                    width: 100%;
                }
                @media (max-width: 1024px) {
                    width: 182px;
                }
                @media (max-width: 558px) {
                    width: 175px;
                    margin-bottom: 28px;
                }
            }
        }
    }
    .fun_img_box {
        background: #e02020;
        .item {
            color: #fff;
            text-align: center;
            .fun_txt {
                // text-align: center;
                display: flex;
                justify-content: center;
                flex-wrap: wrap;
                padding: 32px;

                h3 {
                    color: #fff;
                    width: 100%;
                    font-size: 40px;
                    font-weight: 800;
                }
                p {
                    font-family: Noto Sans SC;
                    max-width: 700px;
                    font-size: 16px;
                    font-weight: normal;
                }
                @media (max-width: 558px) {
                    h3 {
                        font-size: 32px;
                    }
                    p {
                        font-size: 12px;
                    }
                }
            }
            .fun_img {
                img {
                    width: 100%;
                }
            }
        }
    }
    .check_box {
        padding: 80px 20px;
        box-sizing: border-box;
        background: #fff;
        color: #101010;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        // width:630px;
        .check_left {
            margin-right: 40px;
            @media (max-width: 744px) {
                margin-right: 0px;
                margin-bottom: 48px;
            }
        }
        .check_left,
        .check_right {
            & > div:nth-last-child(1) {
                margin-bottom: 0px;
            }
        }
        .check_item {
            width: 332px;
            margin-bottom: 48px;
            .check_title {
                font-size: 16px;
                padding-bottom: 12px;
                border-bottom: 1px solid #b8b8b8;
                font-weight: 800;
            }
            ul {
                .check_li {
                    padding-top: 12px;
                    font-size: 12px;
                    display: flex;
                    justify-content: space-between;
                    div {
                        flex: 1;
                        h5 {
                            font-weight: 600;
                            padding-bottom: 5px;
                        }
                        p {
                            font-weight: 400;
                            color: #878787;
                        }
                    }
                }
            }
        }
    }
    .time_box {
        padding: 80px 0;
        // text-align:center;
        display: flex;
        justify-content: center;
        color: #fff;
        background: #101010;
        .time_content {
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
            background: url("~@/assets/newSpark/time_bg.png") no-repeat;
            background-size: 100%;
            width: 100%;
            padding: 0 0 0 32px;
            @media (max-width: 704px) {
                background: url("~@/assets/newSpark/time_bg1.png") no-repeat;
                background-size: 100%;
            }
            .time_content_box {
                width: 100%;
                max-width: 704px;
                & > * {
                    padding-right: 32px;
                }
                h2 {
                    width: 100%;
                    display: flex;
                    justify-content: center;
                    img {
                        width: 237px;
                        height: 41px;
                    }
                }
                h3 {
                    width: 100%;
                    font-size: 26px;
                    letter-spacing: 0.4em;
                    color: #fff;
                    text-align: center;
                    margin-bottom: 64px;
                }
                .time_txt {
                    margin-bottom: 66px;
                    p {
                        font-size: 16px;
                        text-align: justify;
                        &:nth-child(1) {
                            margin-bottom: 30px;
                        }
                    }
                }
                .wrapper {
                    padding-right: 0;
                }
            }
        }
    }
}
.left_button_box {
    display: flex;
    justify-content: center;
    position: relative;
    img {
        width: 144px;
        height: 44px;
    }
    > img:nth-child(1) {
        margin-right: 32px;
    }
    p {
        position: absolute;
        width: 100%;
        top: 53px;
        text-align: center;
        font-weight: normal;
        font-size: 12px;
        color: #fff;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/spark.vue